// @flow
import { easing, expandIn, rotate360, vanish } from '~/core/constants/animations';
import { getBgColorKey, saveStates } from '~/core/constants/components/widgets/buttons/async';
import generalIcons from '~/core/constants/icons/general-svg';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

const spinnerComponentSize = '2em';
const spinnerDuration = '3s';

export const SpinnerComponent = styled.div`
    background-color: ${({ theme: { primaryBtnColors }, saveState }) => primaryBtnColors[getBgColorKey(saveState)]};
    height: ${spinnerComponentSize};
    overflow: hidden;
    width: ${spinnerComponentSize};

    ${({ saveState }) => {
        const transitionStates = [saveStates.SAVED_END, saveStates.SAVE_ERROR_END];
        const displaySavingStates = [saveStates.SAVING, saveStates.SAVED, saveStates.SAVE_ERROR];
        const opacity = displaySavingStates.includes(saveState) ? 1 : 0;
        const width = displaySavingStates.includes(saveState) ? spinnerComponentSize : 0;
        const transition = transitionStates.includes(saveState)
            ? 'opacity 0s ease-in-out, width 0.25s ease-in-out 0.25s, margin 0.25s ease-in-out 0.25s'
            : 'opacity 0s ease-in-out 0.8s, width 0.3s ease-in-out 0.5s, margin 0.3s ease-in-out 0.5s';
        const margin = displaySavingStates.includes(saveState) ? '0.25em 0 0 0.5em' : '0.25em 0 0';
        return `
            margin: ${margin};
			opacity: ${opacity};
			transition: ${transition};
            width: ${width};
		`;
    }};
`;

export const SpinnerContainer = styled.div`
    background-color: inherit;
    height: 100%;
    position: relative;
    width: 100%;
`;

export const SpinnerPartsContainer = styled.div`
    background-color: inherit;
    position: relative;
    height: 100%;
    width: 100%;
    ${({ saveState }) => {
        const hideStates = [saveStates.SAVED, saveStates.SAVE_ERROR];
        return `display: ${hideStates.includes(saveState) ? 'none' : 'block'}`;
    }};
`;

const SpinnerBase = styled.div`
    background-color: inherit;
    height: 100%;
    overflow: hidden;
    position: absolute;
    width: 50%;
`;

export const Spinner = SpinnerBase.extend`
    background-color: inherit;
    animation: ${rotate360} ${spinnerDuration} linear infinite;
    transform-origin: 100% 50%;
`;

const BaseSVGIcon = styled(SVGIcon).attrs({ type: generalIcons.CIRCLE_OUTLINE })`
    height: 100%;
    width: 100%;

    & g {
        fill: ${props => props.theme.white};
    }
`;

export const SpinnerIcon = BaseSVGIcon.extend`
    height: 200%;
    transform: translateY(-25%);
    width: 200%;
`;

export const Filler = SpinnerBase.extend`
    animation: ${vanish} ${spinnerDuration} linear infinite reverse;
    background-color: inherit;
    left: 50%;
`;

export const FillerIcon = SpinnerIcon.extend`transform: translate(-50%, -25%);`;

export const Mask = styled.div`
    animation: ${vanish} ${spinnerDuration} linear infinite;
    background-color: inherit;
    height: 100%;
    opacity: 1;
    overflow: hidden;
    position: absolute;
    width: 50%;
`;

export const MaskHiddenChild = styled.div`transform: translateX(-100%);`;

export const OverlayIcon = BaseSVGIcon.extend`
    left: 0;
    opacity: 0.5;
    position: absolute;
    transform: translate3d(0, 0, 0);
`;

export const Tick = BaseSVGIcon.extend.attrs({ type: generalIcons.TICK_ONE })`
    left: 0;
    position: absolute;
    visibility: hidden;

    ${({ saveState }) => {
        if (saveState === saveStates.SAVED) {
            return `
                animation: ${expandIn} 0.5s ${easing.bounce} 1;
                visibility: visible;
            `;
        }
    }};
`;

export const Cross = styled(BaseSVGIcon).attrs({ type: generalIcons.CLOSE })`
    left: 0;
    position: absolute;
    visibility: hidden;

    ${({ saveState }) => {
        if (saveState === saveStates.SAVE_ERROR) {
            return `
                animation: ${expandIn} 0.5s ${easing.bounce} 1;
                visibility: visible;
            `;
        }
    }};
`;

export const SolidCircle = BaseSVGIcon.extend.attrs({ type: generalIcons.CIRCLE_OUTLINE })`
    left: 0;
    opacity: ${({ saveState }) => (saveState === saveStates.SAVE_ERROR ? 1 : 0)};
    position: absolute;
    transition: opacity 0.25s ${easing.bounce};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/async/progress/styles.js